import { render, staticRenderFns } from "./no-info.vue?vue&type=template&id=9d7213b0&scoped=true&"
import script from "./no-info.vue?vue&type=script&lang=js&"
export * from "./no-info.vue?vue&type=script&lang=js&"
import style0 from "./no-info.vue?vue&type=style&index=0&id=9d7213b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7213b0",
  null
  
)

export default component.exports